import { ButtonHTMLAttributes } from "react";

type Props = ButtonHTMLAttributes<HTMLButtonElement>;

export default function SolidButton({ className, disabled, ...others }: Props) {
  const disabledClasses = "bg-[#D6D6D6] border-[#D6D6D6] cursor-not-allowed";
  const solidClasses = "bg-custom-black border-[#131313]";
  const buttonClassName = `${
    disabled ? disabledClasses : solidClasses
  } h-[45px] text-white border-solid border bg-white font-chivo-regular uppercase tracking-[1.3px] ${className}`;

  return <button disabled={disabled} className={buttonClassName} {...others} />;
}
